module.exports = __webpack_public_path__ + "static/media/r9.ce2f45bf.jpg";